import React, { useEffect, useState } from "react";
import { ImageLink } from "../utils/constant";
import { UploadCloud } from "lucide-react";
import "./styles/ImageUpload.css";

const ImageUploadDragAndDrop = ({
  id,
  label,
  value,
  onChange,
  error,
  touched,
  accept = "image/*",
}) => {
  const [preview, setPreview] = useState("");
  const [isDragging, setIsDragging] = useState(false);

  useEffect(() => {
    if (!value) {
      setPreview("");
      return;
    }

    if (typeof value !== "string") {
      const objectUrl = URL.createObjectURL(value);
      setPreview(objectUrl);
      return () => URL.revokeObjectURL(objectUrl);
    }

    setPreview(ImageLink(value));
  }, [value]);

  const handleFile = (file) => {
    if (file) onChange(file);
  };

  return (
    <div className="image-upload-wrapper">
      <label className="col-form-label  ">{label}</label>

      <div
        className={`upload-box ${isDragging ? "active" : ""} ${
          preview ? "has-preview" : ""
        }`}
        onDragOver={(e) => {
          e.preventDefault();
          setIsDragging(true);
        }}
        onDragLeave={() => setIsDragging(false)}
        onDrop={(e) => {
          e.preventDefault();
          setIsDragging(false);
          handleFile(e.dataTransfer.files[0]);
        }}
      >
        <input
          id={id}
          name={id}
          type="file"
          accept={accept}
          onChange={(e) => handleFile(e.target.files[0])}
          className="file-input"
        />
        {preview ? (
          <img src={preview} alt="preview" className="inside-preview" />
        ) : (
          <div className="upload-content">
            <div className="icon-wrapper">
              <UploadCloud size={42} strokeWidth={1.5} color="#e4715f" />
            </div>

            <h6>
              Drag & Drop or <span>Browse</span>
            </h6>

            <small>PNG, JPG, WEBP (Max 2MB)</small>
          </div>
        )}
      </div>

      {error && touched && <small className="text-danger">{error}</small>}
    </div>
  );
};

export default ImageUploadDragAndDrop;
